export type TagLabelNamespace = 'amenities' | 'labels'

export type TagLabelLocale = 'de' | 'en'

type TagLabelTable = Record<TagLabelNamespace, Record<string, string>>

const DE: TagLabelTable = {
  amenities: {
    Indoor: 'Drinnen',
    Outdoor: 'Draußen',
    FamilyFriendly: 'Familienfreundlich',
    LiveMusic: 'Live-Musik',
    Rooftop: 'Dachterrasse',
    LateNight: 'Spätabend',
    StudentDiscounts: 'Studentenrabatte',
    FreeWifi: 'Kostenloses WLAN',
    Waterfront: 'Am Wasser',
    Elegant: 'Elegant',
    Swimming: 'Schwimmen',
    BestCocktails: 'Beste Cocktails',
    Garden: 'Garten',
    Spa: 'Spa',
    Premium: 'Premium',
    Reggae: 'Reggae',
    Jazz: 'Jazz',
    Piano: 'Piano',
    GroupActivity: 'Gruppenaktivität',
    EasyAccess: 'Einfacher Zugang',
    WheelchairAccessible: 'Rollstuhlgerecht',
    DateSpot: 'Date-Spot',
    SoloAdventure: 'Solo-Abenteuer',
    LgbtqFriendly: 'LGBTQ-freundlich',
    PetFriendly: 'Tierfreundlich',
    OpenAir: 'Open Air',
    OnlineEvent: 'Online-Event',
    Catering: 'Catering',
    WiFi: 'WLAN',
    Takeaway: 'Zum Mitnehmen',
    PublicViewing: 'Public Viewing',
    ChangingRoom: 'Umkleideraum',
    OutdoorPlayArea: 'Außenspielbereich',
    Delivery: 'Lieferservice',
    Brunch: 'Brunch',
    FarmProducts: 'Hofprodukte',
    IndoorPlayArea: 'Innenspielbereich',
    LunchMenu: 'Mittagsmenü',
    Breakfast: 'Frühstück',
    HighChairs: 'Kinderstühle',
    Restrooms: 'Toiletten',
    HipHop: 'Hip-Hop',
    ParkingAvailable: 'Parkplatz vorhanden',
    DnB: 'Drum and Bass',
    Electronic: 'Electronic',
    Schlager: 'Schlager',
    Acoustic: 'Akustik',
    Indoors: 'Innenbereich',
    Pop: 'Pop',
    StandUp: 'Stand-up Comedy',
    ClassicRock: 'Classic Rock',
    Metal: 'Metal',
  },
  labels: {
    Acoustic: 'Akustisch',
    AdrenalineKick: 'Adrenalin-Kick',
    Afterwork: 'Afterwork',
    AllYouCanEat: 'All You Can Eat',
    American: 'Amerikanisch',
    Art: 'Kunst',
    Asian: 'Asiatisch',
    Austrian: 'Österreichisch',
    Bakery: 'Bäckerei',
    BBQ: 'BBQ',
    BeerGarden: 'Biergarten',
    BestCocktails: 'Beste Cocktails',
    BestMusic: 'Beste Musik',
    BestSushi: 'Bestes Sushi',
    Breakfast: 'Frühstück',
    Brunch: 'Brunch',
    Burger: 'Burger',
    Caribbean: 'Karibisch',
    ChampagneBar: 'Champagner-Bar',
    Charming: 'Charmant',
    Chinese: 'Chinesisch',
    Cinema: 'Kino',
    Climbing: 'Klettern',
    Club: 'Club',
    CocktailBar: 'Cocktailbar',
    CoffeeHouse: 'Kaffeehaus',
    ContemporaryArt: 'Zeitgenössische Kunst',
    Cozy: 'Gemütlich',
    CraftBeer: 'Craft-Bier',
    CreativeCuisine: 'Kreative Küche',
    DanceMusic: 'Tanzmusik',
    DateNight: 'Date Night',
    DessertBar: 'Dessert-Bar',
    Disco: 'Disco',
    DiverseSelection: 'Vielfältige Auswahl',
    DJSets: 'DJ-Sets',
    DogFriendly: 'Hundefreundlich',
    Elegant: 'Elegant',
    Exclusive: 'Exklusiv',
    Exhibition: 'Ausstellung',
    FamilyFriendly: 'Familienfreundlich',
    Fancy: 'Schick',
    FineDining: 'Gehobene Küche',
    FoodTrucks: 'Food Trucks',
    FreshFood: 'Frische Speisen',
    Fusion: 'Fusion',
    Gallery: 'Galerie',
    Garden: 'Garten',
    GlutenFree: 'Glutenfrei',
    GoKart: 'Go-Kart',
    Gourmet: 'Gourmet',
    Greek: 'Griechisch',
    Gym: 'Fitnessstudio',
    HappyHour: 'Happy Hour',
    Health: 'Gesundheit',
    HiddenGem: 'Geheimtipp',
    Hipster: 'Hipster',
    HouseMusic: 'House-Musik',
    IceCream: 'Eis',
    Iconic: 'Ikonisch',
    IndieMusic: 'Indie-Musik',
    Indian: 'Indisch',
    Indoor: 'Innenbereich',
    InstagramWorthy: 'Instagram-würdig',
    Intimate: 'Intim',
    Italian: 'Italienisch',
    Japanese: 'Japanisch',
    Jazz: 'Jazz',
    KidsArea: 'Kinderbereich',
    Korean: 'Koreanisch',
    LateNight: 'Spätabends',
    LatinMusic: 'Lateinamerikanische Musik',
    LGBTQFriendly: 'LGBTQ-freundlich',
    LiveDJ: 'Live-DJ',
    LiveMusic: 'Live-Musik',
    LivePerformance: 'Live-Performance',
    LiveSports: 'Live-Sport',
    Local: 'Lokal',
    Lounge: 'Lounge',
    Lunch: 'Mittagessen',
    Market: 'Markt',
    Mediterranean: 'Mediterran',
    Mexican: 'Mexikanisch',
    MichelinStar: 'Michelin-Stern',
    MiddleEastern: 'Nahöstlich',
    Modern: 'Modern',
    Museum: 'Museum',
    MusicVenue: 'Musiklokal',
    NaturalWine: 'Naturwein',
    Nightclub: 'Nachtclub',
    OpenAir: 'Open Air',
    Organic: 'Bio',
    Outdoor: 'Außenbereich',
    PanoramicView: 'Panoramablick',
    Parkour: 'Parkour',
    Parties: 'Partys',
    PartyAndClubbing: 'Partys & Clubs',
    ClubNights: 'Clubnächte',
    TechnoAndElectronic: 'Techno & Elektro',
    StudentParties: 'Studentenpartys',
    ThemeParties: 'Mottopartys',
    Pasta: 'Pasta',
    Patio: 'Terrasse',
    PetFriendly: 'Haustierfreundlich',
    Pizza: 'Pizza',
    Poolside: 'Am Pool',
    Premium: 'Premium',
    Pub: 'Pub',
    Racing: 'Rennsport',
    Ramen: 'Ramen',
    Regional: 'Regional',
    Relaxing: 'Entspannend',
    Restaurant: 'Restaurant',
    Rooftop: 'Dachterrasse',
    Rustic: 'Rustikal',
    Seafood: 'Meeresfrüchte',
    Seasonal: 'Saisonal',
    Sexy: 'Sexy',
    SignatureCocktails: 'Signature-Cocktails',
    SmoothVibes: 'Smooth Vibes',
    SoulMusic: 'Soul-Musik',
    Spanish: 'Spanisch',
    SportsBar: 'Sportbar',
    Steak: 'Steak',
    StreetArt: 'Street Art',
    StreetFood: 'Street Food',
    Stylish: 'Stylisch',
    Sushi: 'Sushi',
    Swimming: 'Schwimmen',
    Tapas: 'Tapas',
    Techno: 'Techno',
    Terrace: 'Terrasse',
    Thai: 'Thailändisch',
    Themed: 'Thematisch',
    Traditional: 'Traditionell',
    Trendy: 'Trendig',
    Turkish: 'Türkisch',
    Unique: 'Einzigartig',
    Upscale: 'Gehoben',
    Vegan: 'Vegan',
    Vegetarian: 'Vegetarisch',
    Vietnamese: 'Vietnamesisch',
    Views: 'Aussicht',
    Vintage: 'Vintage',
    Waterfront: 'Am Wasser',
    Wellness: 'Wellness',
    WhiskeyBar: 'Whiskey-Bar',
    WiFi: 'WLAN',
    WineBar: 'Weinbar',
    CiderBar: 'Mostschänke',
    MountainHut: 'Berghütte',
    Markets: 'Märkte',
    Conference: 'Kongresse',
    Yoga: 'Yoga',
    ActionAndSports: 'Action & Sport',
    SpectatorSports: 'Zuschauersport',
    IceHockey: 'Eishockey',
    Handball: 'Handball',
    Equestrian: 'Reitsport',
    MartialArts: 'Kampfsport',
    Ballett: 'Ballett',
    Basketball: 'Basketball',
    Bistro: 'Bistro',
    BarsAndNightlife: 'Bars & Nachtleben',
    Blues: 'Blues',
    BowlingAndBilliards: 'Bowling & Billard',
    ClassicRock: 'Classic Rock',
    Clubbing: 'Clubbing',
    Comedy: 'Comedy',
    Country: 'Country',
    CrossFit: 'CrossFit',
    CultureAndActivities: 'Kultur & Aktivitäten',
    Cycling: 'Radfahren',
    Electronic: 'Electronic',
    Schlager: 'Schlager',
    Entertainment: 'Unterhaltung',
    FastFood: 'Fast Food',
    Fitness: 'Fitness',
    Folk: 'Folk',
    FoodAndDrinks: 'Essen & Trinken',
    Football: 'Football',
    FreeWifi: 'Kostenloses WLAN',
    Gastropub: 'Gastropub',
    HealthAndFitness: 'Gesundheit & Fitness',
    HeavyMetal: 'Heavy Metal',
    HipHop: 'Hip Hop',
    IceCafe: 'Eiscafé',
    IndoorActivities: 'Indoor-Aktivitäten',
    InternationalCuisine: 'Internationale Küche',
    Kayaking: 'Kajakfahren',
    Metal: 'Metal',
    MixedArts: 'Gemischte Künste',
    Motorsport: 'Motorsport',
    Music: 'Musik',
    OutdoorActivities: 'Outdoor-Aktivitäten',
    Paintball: 'Paintball',
    ParkingAvailable: 'Parkplatz vorhanden',
    Pilates: 'Pilates',
    Pizzeria: 'Pizzeria',
    Pop: 'Pop',
    PriceHigh: 'Hoher Preis',
    PriceLow: 'Niedriger Preis',
    PriceMedium: 'Mittlerer Preis',
    RAndB: 'R&B',
    Reggae: 'Reggae',
    Restaurants: 'Restaurants',
    Rock: 'Rock',
    RoofTopBar: 'Rooftop-Bar',
    Running: 'Laufen',
    Skateboarding: 'Skateboarden',
    SnackBar: 'Snackbar',
    Soccer: 'Fußball',
    Spinning: 'Spinning',
    Steakhouse: 'Steakhouse',
    Surfing: 'Surfen',
    Theater: 'Theater',
    TrendyBar: 'Trendige Bar',
    VeganRestaurant: 'Veganes Restaurant',
    Volleyball: 'Volleyball',
    WheelchairAccessible: 'Rollstuhlgerecht',
    WineLounge: 'Wein-Lounge',
    Zumba: 'Zumba',
    Specialties: 'Spezialitäten',
    CafesAndSnacks: 'Cafés & Snacks',
    SummerActivities: 'Sommeraktivitäten',
    WinterActivities: 'Winteraktivitäten',
    WellnessAndRelaxation: 'Wellness & Entspannung',
    BodyAndMind: 'Körper & Geist',
    EventsAndMarkets: 'Events & Märkte',
    ExperienceSports: 'Erlebnis-Sport',
    Culture: 'Kultur',
    OutdoorAdventure: 'Outdoor-Abenteuer',
    Deli: 'Delikatessen',
    French: 'Französisch',
    IceCreamParlor: 'Eisdiele',
    College: 'College',
    Bars: 'Bars',
    GayBar: 'Gay Bar',
    PastryShop: 'Konditorei',
    Barbecue: 'Grill',
    ShishaBar: 'Shisha-Bar',
    BeachBar: 'Strandbar',
    IrishPub: 'Irish Pub',
    SnacksAndCafes: 'Snacks & Cafés',
    CountryBar: 'Country-Bar',
    SummerSports: 'Sommersport',
    WinterSports: 'Wintersport',
    IceCreamCafe: 'Eiscafé',
    WaterSports: 'Wassersport',
    Meditation: 'Meditation',
    WellnessRelaxation: 'Wellness-Entspannung',
    Sauna: 'Sauna',
    FitnessClasses: 'Fitnesskurse',
    Diving: 'Tauchen',
    Spa: 'Spa',
    Massage: 'Massage',
    Tennis: 'Tennis',
    MountainBiking: 'Mountainbiking',
    CulinaryEvents: 'Kulinarische Events',
    Discos: 'Discos',
    Bowling: 'Bowling',
    BungeeJumping: 'Bungee-Jumping',
    EscapeRooms: 'Escape Rooms',
    Hiking: 'Wandern',
    Festivals: 'Festivals',
    TradeFairs: 'Messen',
    Golf: 'Golf',
    FunFairs: 'Volksfeste',
    Motorsports: 'Motorsport',
    Piano: 'Piano',
    ComedyShows: 'Comedy-Shows',
    Concerts: 'Konzerte',
    TheaterPerformances: 'Theateraufführungen',
    ShootingSports: 'Schießsport',
    Karaoke: 'Karaoke',
    ChristmasMarkets: 'Weihnachtsmärkte',
    Workshops: 'Workshops',
    DanceEvents: 'Tanzveranstaltungen',
    LiveMusicAndEntertainment: 'Live-Musik & Entertainment',
    RoofTop: 'Dachterrasse',
    DnB: 'Drum & Bass',
    StandUp: 'Stand-up',
    Panorama: 'Panorama',
    SkillBuilding: 'Kompetenzaufbau',
    Creative: 'Kreativ',
    Sightseeing: 'Sightseeing',
    Relax: 'Entspannen',
    DateSpot: 'Für Dates',
    Socialize: 'Gesellig',
    SoloAdventure: 'Solo-Abenteuer',
    GroupActivity: 'Gruppenaktivität',
    Technology: 'Technologie',
    Inspiration: 'Inspiration',
    Indoors: 'Innenbereich',
    Party: 'Party',
    Networking: 'Networking',
    StudentDiscounts: 'Studentenrabatte',
    LgbtqFriendly: 'LGBTQ-freundlich',
    EasyAccess: 'Leichter Zugang',
    OnlineEvent: 'Online-Event',
    Catering: 'Catering',
    Takeaway: 'Zum Mitnehmen',
    PublicViewing: 'Public Viewing',
    ChangingRoom: 'Umkleidekabine',
    OutdoorPlayArea: 'Outdoor-Spielbereich',
    Delivery: 'Lieferung',
    FarmProducts: 'Hofprodukte',
    IndoorPlayArea: 'Indoor-Spielbereich',
    LunchMenu: 'Mittagsmenü',
    HighChairs: 'Hochstühle',
    Restrooms: 'Toiletten',
  },
}

const EN: TagLabelTable = {
  amenities: {
    Indoor: 'Indoor',
    Outdoor: 'Outdoor',
    FamilyFriendly: 'Family Friendly',
    LiveMusic: 'Live Music',
    Rooftop: 'Rooftop',
    LateNight: 'Late Night',
    StudentDiscounts: 'Student Discounts',
    FreeWifi: 'Free Wifi',
    Waterfront: 'Waterfront',
    Elegant: 'Elegant',
    Swimming: 'Swimming',
    BestCocktails: 'Best Cocktails',
    Garden: 'Garden',
    Spa: 'Spa',
    Premium: 'Premium',
    Reggae: 'Reggae',
    Jazz: 'Jazz',
    Piano: 'Piano',
    GroupActivity: 'Group Activity',
    EasyAccess: 'Easy Access',
    WheelchairAccessible: 'Wheelchair Accessible',
    DateSpot: 'Date Spot',
    SoloAdventure: 'Solo Adventure',
    LgbtqFriendly: 'LGBTQ Friendly',
    PetFriendly: 'Pet Friendly',
    OpenAir: 'Open Air',
    OnlineEvent: 'Online Event',
    Catering: 'Catering',
    WiFi: 'WiFi',
    Takeaway: 'Takeaway',
    PublicViewing: 'Public Viewing',
    ChangingRoom: 'Changing Room',
    OutdoorPlayArea: 'Outdoor Play Area',
    Delivery: 'Delivery',
    Brunch: 'Brunch',
    FarmProducts: 'Farm Products',
    IndoorPlayArea: 'Indoor Play Area',
    LunchMenu: 'Lunch Menu',
    Breakfast: 'Breakfast',
    HighChairs: 'High Chairs',
    Restrooms: 'Restrooms',
    HipHop: 'Hip-Hop',
    ParkingAvailable: 'Parking Available',
    DnB: 'Drum and Bass',
    Electronic: 'Electronic',
    Schlager: 'Schlager',
    Acoustic: 'Acoustic',
    Indoors: 'Indoors',
    Pop: 'Pop',
    StandUp: 'Stand-Up Comedy',
    ClassicRock: 'Classic Rock',
    Metal: 'Metal',
  },
  labels: {
    Acoustic: 'Acoustic',
    AdrenalineKick: 'Adrenaline Kick',
    Afterwork: 'Afterwork',
    AllYouCanEat: 'All You Can Eat',
    American: 'American',
    Art: 'Art',
    Asian: 'Asian',
    Austrian: 'Austrian',
    Bakery: 'Bakery',
    BBQ: 'BBQ',
    BeerGarden: 'Beer Garden',
    BestCocktails: 'Best Cocktails',
    BestMusic: 'Best Music',
    BestSushi: 'Best Sushi',
    Breakfast: 'Breakfast',
    Brunch: 'Brunch',
    Burger: 'Burger',
    Caribbean: 'Caribbean',
    ChampagneBar: 'Champagne Bar',
    Charming: 'Charming',
    Chinese: 'Chinese',
    Cinema: 'Cinema',
    Climbing: 'Climbing',
    Club: 'Club',
    CocktailBar: 'Cocktail Bar',
    CoffeeHouse: 'Coffee House',
    ContemporaryArt: 'Contemporary Art',
    Cozy: 'Cozy',
    CraftBeer: 'Craft Beer',
    CreativeCuisine: 'Creative Cuisine',
    DanceMusic: 'Dance Music',
    DateNight: 'Date Night',
    DessertBar: 'Dessert Bar',
    Disco: 'Disco',
    DiverseSelection: 'Diverse Selection',
    DJSets: 'DJ Sets',
    DogFriendly: 'Dog Friendly',
    Elegant: 'Elegant',
    Exclusive: 'Exclusive',
    Exhibition: 'Exhibition',
    FamilyFriendly: 'Family Friendly',
    Fancy: 'Fancy',
    FineDining: 'Fine Dining',
    FoodTrucks: 'Food Trucks',
    FreshFood: 'Fresh Food',
    Fusion: 'Fusion',
    Gallery: 'Gallery',
    Garden: 'Garden',
    GlutenFree: 'Gluten Free',
    GoKart: 'Go Kart',
    Gourmet: 'Gourmet',
    Greek: 'Greek',
    Gym: 'Gym',
    HappyHour: 'Happy Hour',
    Health: 'Health',
    HiddenGem: 'Hidden Gem',
    Hipster: 'Hipster',
    HouseMusic: 'House Music',
    IceCream: 'Ice Cream',
    Iconic: 'Iconic',
    IndieMusic: 'Indie Music',
    Indian: 'Indian',
    Indoor: 'Indoor',
    InstagramWorthy: 'Instagram Worthy',
    Intimate: 'Intimate',
    Italian: 'Italian',
    Japanese: 'Japanese',
    Jazz: 'Jazz',
    KidsArea: 'Kids Area',
    Korean: 'Korean',
    LateNight: 'Late Night',
    LatinMusic: 'Latin Music',
    LGBTQFriendly: 'LGBTQ Friendly',
    LiveDJ: 'Live DJ',
    LiveMusic: 'Live Music',
    LivePerformance: 'Live Performance',
    LiveSports: 'Live Sports',
    Local: 'Local',
    Lounge: 'Lounge',
    Lunch: 'Lunch',
    Market: 'Market',
    Mediterranean: 'Mediterranean',
    Mexican: 'Mexican',
    MichelinStar: 'Michelin Star',
    MiddleEastern: 'Middle Eastern',
    Modern: 'Modern',
    Museum: 'Museum',
    MusicVenue: 'Music Venue',
    NaturalWine: 'Natural Wine',
    Nightclub: 'Nightclub',
    OpenAir: 'Open Air',
    Organic: 'Organic',
    Outdoor: 'Outdoor',
    PanoramicView: 'Panoramic View',
    Parkour: 'Parkour',
    Parties: 'Parties',
    PartyAndClubbing: 'Party & Clubbing',
    ClubNights: 'Club Nights',
    TechnoAndElectronic: 'Techno & Electronic',
    StudentParties: 'Student Parties',
    ThemeParties: 'Theme Parties',
    Pasta: 'Pasta',
    Patio: 'Patio',
    PetFriendly: 'Pet Friendly',
    Pizza: 'Pizza',
    Poolside: 'Poolside',
    Premium: 'Premium',
    Pub: 'Pub',
    Racing: 'Racing',
    Ramen: 'Ramen',
    Regional: 'Regional',
    Relaxing: 'Relaxing',
    Restaurant: 'Restaurant',
    Rooftop: 'Rooftop',
    Rustic: 'Rustic',
    Seafood: 'Seafood',
    Seasonal: 'Seasonal',
    Sexy: 'Sexy',
    SignatureCocktails: 'Signature Cocktails',
    SmoothVibes: 'Smooth Vibes',
    SoulMusic: 'Soul Music',
    Spanish: 'Spanish',
    SportsBar: 'Sports Bar',
    Steak: 'Steak',
    StreetArt: 'Street Art',
    StreetFood: 'Street Food',
    Stylish: 'Stylish',
    Sushi: 'Sushi',
    Swimming: 'Swimming',
    Tapas: 'Tapas',
    Techno: 'Techno',
    Terrace: 'Terrace',
    Thai: 'Thai',
    Themed: 'Themed',
    Traditional: 'Traditional',
    Trendy: 'Trendy',
    Turkish: 'Turkish',
    Unique: 'Unique',
    Upscale: 'Upscale',
    Vegan: 'Vegan',
    Vegetarian: 'Vegetarian',
    Vietnamese: 'Vietnamese',
    Views: 'Views',
    Vintage: 'Vintage',
    Waterfront: 'Waterfront',
    Wellness: 'Wellness',
    WhiskeyBar: 'Whiskey Bar',
    WiFi: 'WiFi',
    WineBar: 'Wine Bar',
    CiderBar: 'Cider Bar',
    MountainHut: 'Mountain Hut',
    Markets: 'Markets',
    Conference: 'Conferences',
    Yoga: 'Yoga',
    ActionAndSports: 'Action & Sports',
    SpectatorSports: 'Spectator Sports',
    IceHockey: 'Ice Hockey',
    Handball: 'Handball',
    Equestrian: 'Equestrian',
    MartialArts: 'Martial Arts',
    Ballett: 'Ballet',
    Basketball: 'Basketball',
    Bistro: 'Bistro',
    BarsAndNightlife: 'Bars & Nightlife',
    Blues: 'Blues',
    BowlingAndBilliards: 'Bowling & Billiards',
    ClassicRock: 'Classic Rock',
    Clubbing: 'Clubbing',
    Comedy: 'Comedy',
    Country: 'Country',
    CrossFit: 'CrossFit',
    CultureAndActivities: 'Culture & Activities',
    Cycling: 'Cycling',
    Electronic: 'Electronic',
    Schlager: 'Schlager',
    Entertainment: 'Entertainment',
    FastFood: 'Fast Food',
    Fitness: 'Fitness',
    Folk: 'Folk',
    FoodAndDrinks: 'Food & Drinks',
    Football: 'Football',
    FreeWifi: 'Free WiFi',
    Gastropub: 'Gastropub',
    HealthAndFitness: 'Health & Fitness',
    HeavyMetal: 'Heavy Metal',
    HipHop: 'Hip Hop',
    IceCafe: 'Ice Cafe',
    IndoorActivities: 'Indoor Activities',
    InternationalCuisine: 'International Cuisine',
    Kayaking: 'Kayaking',
    Metal: 'Metal',
    MixedArts: 'Mixed Arts',
    Motorsport: 'Motorsport',
    Music: 'Music',
    OutdoorActivities: 'Outdoor Activities',
    Paintball: 'Paintball',
    ParkingAvailable: 'Parking Available',
    Pilates: 'Pilates',
    Pizzeria: 'Pizzeria',
    Pop: 'Pop',
    PriceHigh: 'High Price',
    PriceLow: 'Low Price',
    PriceMedium: 'Medium Price',
    RAndB: 'R&B',
    Reggae: 'Reggae',
    Restaurants: 'Restaurants',
    Rock: 'Rock',
    RoofTopBar: 'Rooftop Bar',
    Running: 'Running',
    Skateboarding: 'Skateboarding',
    SnackBar: 'Snack Bar',
    Soccer: 'Soccer',
    Spinning: 'Spinning',
    Steakhouse: 'Steakhouse',
    Surfing: 'Surfing',
    Theater: 'Theater',
    TrendyBar: 'Trendy Bar',
    VeganRestaurant: 'Vegan Restaurant',
    Volleyball: 'Volleyball',
    WheelchairAccessible: 'Wheelchair Accessible',
    WineLounge: 'Wine Lounge',
    Zumba: 'Zumba',
    Specialties: 'Specialties',
    CafesAndSnacks: 'Cafes & Snacks',
    SummerActivities: 'Summer Activities',
    WinterActivities: 'Winter Activities',
    WellnessAndRelaxation: 'Wellness & Relaxation',
    BodyAndMind: 'Body & Mind',
    EventsAndMarkets: 'Events & Markets',
    ExperienceSports: 'Experience Sports',
    Culture: 'Culture',
    OutdoorAdventure: 'Outdoor Adventure',
    Deli: 'Deli',
    French: 'French',
    IceCreamParlor: 'Ice Cream Parlor',
    College: 'College',
    Bars: 'Bars',
    GayBar: 'Gay Bar',
    PastryShop: 'Pastry Shop',
    Barbecue: 'Barbecue',
    ShishaBar: 'Shisha Bar',
    BeachBar: 'Beach Bar',
    IrishPub: 'Irish Pub',
    SnacksAndCafes: 'Snacks & Cafes',
    CountryBar: 'Country Bar',
    SummerSports: 'Summer Sports',
    WinterSports: 'Winter Sports',
    IceCreamCafe: 'Ice Cream Cafe',
    WaterSports: 'Water Sports',
    Meditation: 'Meditation',
    WellnessRelaxation: 'Wellness Relaxation',
    Sauna: 'Sauna',
    FitnessClasses: 'Fitness Classes',
    Diving: 'Diving',
    Spa: 'Spa',
    Massage: 'Massage',
    Tennis: 'Tennis',
    MountainBiking: 'Mountain Biking',
    CulinaryEvents: 'Culinary Events',
    Discos: 'Discos',
    Bowling: 'Bowling',
    BungeeJumping: 'Bungee Jumping',
    EscapeRooms: 'Escape Rooms',
    Hiking: 'Hiking',
    Festivals: 'Festivals',
    TradeFairs: 'Trade Fairs',
    Golf: 'Golf',
    FunFairs: 'Fun Fairs',
    Motorsports: 'Motorsports',
    Piano: 'Piano',
    ComedyShows: 'Comedy Shows',
    Concerts: 'Concerts',
    TheaterPerformances: 'Theater Performances',
    ShootingSports: 'Shooting Sports',
    Karaoke: 'Karaoke',
    ChristmasMarkets: 'Christmas Markets',
    Workshops: 'Workshops',
    DanceEvents: 'Dance Events',
    LiveMusicAndEntertainment: 'Live Music & Entertainment',
    RoofTop: 'Rooftop',
    DnB: 'Drum & Bass',
    StandUp: 'Stand Up',
    Panorama: 'Panorama',
    SkillBuilding: 'Skill Building',
    Creative: 'Creative',
    Sightseeing: 'Sightseeing',
    Relax: 'Relax',
    DateSpot: 'Date Spot',
    Socialize: 'Socialize',
    SoloAdventure: 'Solo Adventure',
    GroupActivity: 'Group Activity',
    Technology: 'Technology',
    Inspiration: 'Inspiration',
    Indoors: 'Indoors',
    Party: 'Party',
    Networking: 'Networking',
    StudentDiscounts: 'Student Discounts',
    LgbtqFriendly: 'LGBTQ Friendly',
    EasyAccess: 'Easy Access',
    OnlineEvent: 'Online Event',
    Catering: 'Catering',
    Takeaway: 'Takeaway',
    PublicViewing: 'Public Viewing',
    ChangingRoom: 'Changing Room',
    OutdoorPlayArea: 'Outdoor Play Area',
    Delivery: 'Delivery',
    FarmProducts: 'Farm Products',
    IndoorPlayArea: 'Indoor Play Area',
    LunchMenu: 'Lunch Menu',
    HighChairs: 'High Chairs',
    Restrooms: 'Restrooms',
  },
}

/** Display names for tag names from the API ("FamilyFriendly"), per locale and namespace. */
export const TAG_LABELS: Record<TagLabelLocale, TagLabelTable> = { de: DE, en: EN }

/** The translated display name of a tag, or undefined when no translation exists. */
export function translateTagName(
  name: string,
  namespace: TagLabelNamespace,
  locale: TagLabelLocale,
): string | undefined {
  return Object.hasOwn(TAG_LABELS[locale][namespace], name)
    ? TAG_LABELS[locale][namespace][name]
    : undefined
}

const MIN_MATCH_LENGTH = 3

function folded(text: string): string {
  return text
    .normalize('NFD')
    .replace(/\p{Diacritic}/gu, '')
    .toLowerCase()
}

function nameWords(name: string): string {
  return name.replace(/([a-z])([A-Z])/g, '$1 $2')
}

/** Tag names whose German or English label, or own name, contains the search term. */
export function tagNamesMatching(term: string): string[] {
  const needle = folded(term.trim())
  if (needle.length < MIN_MATCH_LENGTH) return []
  const names = new Set<string>()
  for (const locale of ['de', 'en'] as const) {
    for (const namespace of ['labels', 'amenities'] as const) {
      for (const [name, label] of Object.entries(TAG_LABELS[locale][namespace])) {
        if (folded(label).includes(needle) || folded(nameWords(name)).includes(needle)) {
          names.add(name)
        }
      }
    }
  }
  return [...names]
}
